export const GET_USERS = '[User Action] Get Users';
export const CONFIRMED_GET_USERS = '[User Action] Confirmed Get Users';
export const CONFIRMED_DELETE_USER_ACTION = '[User Action] Confirmed Delete User';
export const CREATE_USER_ACTION = '[User Action] Create User';
export const CONFIRMED_CREATE_USER_ACTION = '[User Action] Confirmed Create User';
